import Announcer from "./Announcer.vue";

let announcer = new Announcer();
announcer.$mount();
document.body.appendChild(announcer.$el);

export let announce = (message: string) => {
    (<any>announcer).announce(message);
};